import React, { Component } from 'react';
import Grid from '@material-ui/core/Grid';
import { ProjectDataView } from '../components/ProjectDataView';
import { ProjectKeyInformationView } from '../components/ProjectKeyInformationView';
import { EntityInChargeView } from '../components/EntityInChargeView'
import { ProjectFinancialDataView } from '../components/ProjectFinancialDataView'
import { ProjectDatesView } from '../components/ProjectDatesView'
import { RomReviewView } from '../components/RomReviewView'

import { DashboardProjectDetails } from '../components/DashboardProjectDetails';
import { DashboardRomTemplates } from '../components/DashboardRomTemplates';
import { DashboardRomDocuments } from '../components/DashboardRomDocuments';
import { DashboardDocuments } from '../components/DashboardDocuments';
import { ProjectSelect } from '../components/ProjectSelect'

import Button from '@material-ui/core/Button';
import { inject, observer } from 'mobx-react';
import { stores } from '../store';

import Card from "@material-ui/core/Card";
import CardHeader from "@material-ui/core/CardHeader";
import CardContent from "@material-ui/core/CardContent";
import MUIDataTable from "mui-datatables";

import TextField from '@material-ui/core/TextField';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Autocomplete from '@material-ui/lab/Autocomplete';

import { ProjectData } from "../components/ProjectData";
import { ProjectKeyInformation } from "../components/ProjectKeyInformation";
import { EntityInCharge } from "../components/EntityInCharge";
import { ProjectFinancialData } from "../components/ProjectFinancialData";
import { ProjectDates } from "../components/ProjectDates";
import { RomReview } from "../components/RomReview";
import MaterialTable from 'material-table';
//import Button from "@material-ui/core/Button";
//import { inject, observer } from "mobx-react";
//import { stores } from "../store";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import AttachFileIcon from "@material-ui/icons/AttachFile";
import CloudUploadIcon from "@material-ui/icons/CloudUpload";
import ArrowForwardIcon from '@material-ui/icons/ArrowForward';

import Typography from "@material-ui/core/Typography";

import 'moment-timezone';
import moment from 'moment'

import CircularProgress from '@material-ui/core/CircularProgress';

import {
    typeOfIPAOptions,
    typeOfFAYearOptions,
    typeOfFAMAOptions,
    sectorOptions,
    typeOfAnnualOptions,
    typeOfProjectOptions,
    returnTypeIdNameArrayElement
} from '../components/Enums';

export class ProjectDetailsPage extends Component {
    constructor(props) {
        super(props);
        this.state = {
            typeOfROM: "",
            projectTitle: "",
            projectNumber: "",
            status: "",
            typeOfProject: "",
            sector: "",
            smcsCode: "",
            cfcuContractManager: "",
            deuaSectorExpert: "",
            deuaMonitoringExpert: "",
            eudSectorManager: "",
            beneficiaryInstitution: "",
            beneficiaryUnitDepartment: "",
            contractingPartner: "",
            totalBudget: "",
            deuContribution: "",
            nationalCoFinancing: "",
            otherCoFinancing: "",
            mainComponentBudget: "",
            paidAmount: "",
            lastDateOfPayment: "",
            contractorSignatureDate: "",
            projectStartDate: "",
            finalDate: "",
            reasonfortheRomReview: "",
            romExpertName: "",
            soMonitor: "",
            //fieldPhaseStartDate: "",
            actualDate: "",
            plannedDate: "",
            detail: "",
            mrFile: "",
            mqFile: "",
            qualityChecklistFile: "",
            draftTemplateforScheduleFile: "",
            eRomHandbook: "",
            oRomHandbook: "",
            eInGuideline: "",
            oInGuideline: "",
            projects: [],
            projectDocuments: [],
            otherDocuments: [],
            projectDetails: {},
            beneficiaries: [],
            components: [],
            coMonitor: "",
            fieldPhaseStartDate: new Date(),
            fieldPhaseEndDate: new Date(),
            euContribution: "",
            totalFundsDisbursed: "",
            contactAtBeneficiaryInstitution: "",
            teamLeaderPartner: "",
            annualType: "",
            IPAType: "",
            FAType: "",
            FAMAType: "",

            files: [],
            filename: "",
            data: [],

            selectedProjectId: "",
            selectedProject: "",

            isFetching: false,

            fileCategory: "",

            uploadCategories: [
                { TypeId: 4, TypeName: "Contractual" },
                { TypeId: 3, TypeName: "MoMs" },
                { TypeId: 2, TypeName: "Main Reports" },
                { TypeId: 1, TypeName: "Other Outputs" },
            ],

            userType: -1,
            beneficiarieslist: [],

            documentTitle: "",
        };
    }

    async componentDidMount() {

        let pageTokenAuthData = {
            operation: "AuthCheckToken"
        };

        await fetch(global.variables.API_CHECKTOKEN, {
            method: "POST",
            headers: {
                Authorization: "Bearer " + localStorage.getItem("authtoken"),
                Accept: "application/json",
                "Content-Type": "application/json"
            },
            body: JSON.stringify(pageTokenAuthData)
        })
            .then(response => response.json())
            .then(result => {
                if (result.resultstate > 0 ||
                    result.authresp === 2) {
                    window.location.href = "/login";
                }
            }).catch(() => {
                window.location.href = "/login";
            });

        await this.setState({
            projectId: this.props.match.params.id
        });

        let pageData = {
            operation: "GetProjectDetails",
            projectId: this.props.match.params.id
        };

        await fetch(global.variables.API_PROJECTDETAILS_GETDETAILS, {
            method: "POST",
            headers: {
                Authorization: "Bearer " + localStorage.getItem("authtoken"),
                Accept: "application/json",
                "Content-Type": "application/json"
            },
            body: JSON.stringify(pageData)
        })
            .then(response => response.json())
            .then(result => {
                console.log(result);

                this.setState({
                    projectDetails: result.projectdetails[0],

                    projectTitle: result.projectdetails[0].ProjectTitle,
                    beneficiaryInstitution: result.projectdetails[0].BeneficiaryInstitution,
                    beneficiaryUnitDepartment: result.projectdetails[0].BeneficiaryUnitDepartment,
                    cfcuContractManager: result.projectdetails[0].CFCUContractManager,
                    contractingPartner: result.projectdetails[0].ContractingPartner,
                    contractorSignatureDate: result.projectdetails[0].ContractorSignatureDate,
                    deuaMonitoringExpert: result.projectdetails[0].DEUAMonitoringExpert,
                    deuaSectorExpert: result.projectdetails[0].DEUASectorExpert,
                    euContribution: result.projectdetails[0].EUContribution,
                    eudSectorManager: result.projectdetails[0].EUDSectorManager,
                    finalDate: result.projectdetails[0].FinalDate,
                    lastDateOfPayment: result.projectdetails[0].LastDateOfPayment,
                    nationalCoFinancing: result.projectdetails[0].NationalCoFinancing,
                    otherCoFinancing: result.projectdetails[0].OtherCoFinancing,
                    mainComponentBudget: result.projectdetails[0].MainComponentBudget,
                    projectNumber: result.projectdetails[0].ProjectNumber,
                    projectStartDate: result.projectdetails[0].ProjectStartDate,
                    smcsCode: result.projectdetails[0].SMCSCode,
                    typeOfProject: result.projectdetails[0].TypeOfProject,
                    sector: result.projectdetails[0].Sector,
                    status: result.projectdetails[0].Status,
                    totalBudget: result.projectdetails[0].TotalBudget,
                    totalFundsDisbursed: result.projectdetails[0].TotalFundsDisbursed,
                    idProjectDetails: result.projectdetails[0].idProjectDetails,
                    contactAtBeneficiaryInstitution: result.projectdetails[0].ContactAtBeneficiaryInstitution,
                    teamLeaderPartner: result.projectdetails[0].TeamLeaderPartner,
                    annualType: result.projectdetails[0].AnnualType,
                    IPAType: result.projectdetails[0].IPAType,
                    FAType: result.projectdetails[0].FAType,
                    FAMAType: result.projectdetails[0].FAMAType,
                });
            });


        //const projects = [
        //    { title: 'Project 1', no: 1 },
        //    { title: 'Project 2', no: 2 },
        //    { title: 'Project 3', no: 3 },
        //    { title: 'Project 4', no: 4 },
        //    { title: 'Project 5', no: 5 }
        //];

        //const projectDocuments = ["Contract Reports", "Project Reports", "Previous ROM Reports"]
        //const otherDocuments = ["Other Document1", "Other Document2", "Other Document3", "Other Document4", "Other Document5"]
        //const detail = "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Suspendisse sed congue massa. Vestibulum nibh ligula, pharetra non luctus ac, malesuada non sem. Pellentesque ultrices, elit ut pharetra pulvinar, nunc tortor blandit leo, vitae pulvinar purus metus quis ipsum. Phasellus ut tellus augue. Aliquam molestie pulvinar dolor eu malesuada. Aliquam sagittis ultrices nisi, at pulvinar lorem facilisis at. Fusce eu condimentum est. Sed congue libero nisl, vitae cursus dui malesuada ut. Proin eleifend malesuada lorem, nec accumsan nisi placerat ut. Nullam fringilla leo semper hendrerit imperdiet. Fusce a suscipit nulla, quis elementum nibh. Fusce a leo vitae nisl ullamcorper venenatis sit amet et velit. Sed posuere, libero non aliquam varius, leo arcu gravida augue, a luctus mi lorem quis erat. Phasellus consequat tortor quis augue faucibus dictum. Morbi malesuada viverra lacus sit amet aliquet. Fusce et nulla est. Proin interdum nulla id nisi gravida dictum. Proin congue purus ut leo egestas, in condimentum tellus mattis. Sed id ipsum odio. Proin placerat lacus magna, non vehicula diam sollicitudin quis. Pellentesque egestas, dui non suscipit pretium, nisi turpis feugiat quam, quis consequat odio justo a ligula. In blandit purus at elementum scelerisque. Pellentesque sollicitudin eget lacus sit amet laoreet. Fusce sagittis orci sed enim maximus cursus. Praesent tempor neque dignissim congue consequat. Duis consequat egestas dignissim. Donec vehicula magna magna, vel feugiat tortor euismod ac. Proin dui turpis, aliquet vel dui egestas, auctor scelerisque metus. Nam sodales feugiat augue, ac sodales odio porttitor vitae. Aenean nisl ex, eleifend sed lacinia ut, tincidunt id dui. Praesent sed tincidunt lorem. Nam urna sem, accumsan eget justo a, porta lobortis sapien. Pellentesque volutpat pretium metus sit amet tincidunt. Ut sit amet egestas eros."
        const actualDate = "01/01/20"
        const plannedDate = "01/01/20"

        await this.setState({
            //projects: projects,
            //projectDocuments: projectDocuments,
            //otherDocuments: otherDocuments,
            //detail: detail,
            actualDate: actualDate,
            plannedDate: plannedDate

        });

        await this.loadFreeFormWithProjectFiles();
        await this.loadPageMissions();
        await this.loadPageProjects();
        await this.loadPageComponents();
        await this.loadBeneficiaries();

        await this.setState({
            selectedProjectId: this.props.match.params.id,
            selectedProject: this.state.projects.filter(p => {
                return p.idProjectDetails == this.props.match.params.id;
            })[0]
        });

        //console.log("Selected Project: ");
        //console.log(this.state.projects);
        //console.log("***");
        //console.log(this.props.match.params.id);
        //console.log("***");
        //console.log(this.state.selectedProjectId);
        //console.log("***");
        //console.log(this.state.selectedprojectid);
        //console.log("***");
        //console.log(this.state.selectedProject);
        //console.log("***");

        //for (let i = 0; i < this.state.projects.length; i++) {
        //    if (this.state.projects[i].idProjectDetails == this.props.match.params.id) {
        //        this.state.selectedProject = this.state.projects[i];
        //        console.log(this.state.projects[i]);
        //    }
        //}

        //console.log(this.state.projects.filter(p => {
        //    return p.idProjectDetails == this.props.match.params.id;
        //}));
        //console.log("***");

        await this.getUserType();

        await this.setState({
            oRomHandbook: global.variables.API_FILEUPLOADDOWNLOAD_DOWNLOADSTATICFILE + "/" + btoa(localStorage.getItem("authtoken")) + "/5",
            eRomHandbook: global.variables.API_FILEUPLOADDOWNLOAD_DOWNLOADSTATICFILE + "/" + btoa(localStorage.getItem("authtoken")) + "/4",
            oInGuideline: global.variables.API_FILEUPLOADDOWNLOAD_DOWNLOADSTATICFILE + "/" + btoa(localStorage.getItem("authtoken")) + "/3",
            eInGuideline: global.variables.API_FILEUPLOADDOWNLOAD_DOWNLOADSTATICFILE + "/" + btoa(localStorage.getItem("authtoken")) + "/2",
        });
    }

    loadFreeFormWithProjectFiles = async () => {
        let pageData = {
            operation: "LoadFreeFormWithProjectFiles",
            projectid: this.props.match.params.id,
        };

        await fetch(global.variables.API_UPLOADFILESPAGE_GETFREEFORMWITHPROJECTFILES, {
            method: "POST",
            headers: {
                Authorization: "Bearer " + localStorage.getItem("authtoken"),
                Accept: "application/json",
                "Content-Type": "application/json"
            },
            body: JSON.stringify(pageData)
        })
            .then(response => response.json())
            .then(result => {
                console.log(result);

                var resultDataDocuments = result.freeformwithprojectfiles;

                for (var i = 0; i < resultDataDocuments.length; i++) {
                    resultDataDocuments[i].FreeFormProjectFileCategoryName =
                        this.returnArrayElement(this.state.uploadCategories,
                            resultDataDocuments[i].FreeFormProjectFileCategory).TypeName
                }

                this.setState({
                    dataDocuments: resultDataDocuments
                });
            });
    }

    loadPageMissions = async () => {
        let pageData = {
            operation: "GetListOfMisions",
            selectedprojectid: this.props.match.params.id
        };

        await fetch(global.variables.API_PROJECTDETAILS_GETLISTOFMISSIONS, {
            method: "POST",
            headers: {
                Authorization: "Bearer " + localStorage.getItem("authtoken"),
                Accept: "application/json",
                "Content-Type": "application/json"
            },
            body: JSON.stringify(pageData)
        })
            .then(response => response.json())
            .then(result => {
                console.log(result);

                this.setState({
                    dataMissions: result.missions
                });
            });
    }

    loadPageComponents = async () => {
        let pageData = {
            operation: "LoadPageComponents",
            selectedprojectid: this.props.match.params.id
        };

        await fetch(global.variables.API_PROJECTDETAILS_GETCOMPONENTS, {
            method: "POST",
            headers: {
                Authorization: "Bearer " + localStorage.getItem("authtoken"),
                Accept: "application/json",
                "Content-Type": "application/json"
            },
            body: JSON.stringify(pageData)
        })
            .then(response => response.json())
            .then(result => {
                console.log(result);

                let c = result.components;
                for (var i = 0; i < c.length; ++i) {
                    c[i].TypeOfProjectName = returnTypeIdNameArrayElement(typeOfProjectOptions, c[i].TypeOfProject).TypeName;

                    //console.log(c[i].TypeOfProject);
                    //console.log(returnTypeIdNameArrayElement(typeOfProjectOptions, c[i].TypeOfProject));
                    //console.log(returnTypeIdNameArrayElement(typeOfProjectOptions, c[i].TypeOfProject).TypeName);
                    //console.log(c[i].TypeOfProjectName);
                    //console.log("----");
                }

                this.setState({
                    components: c
                });
            });
    }

    loadPageProjects = async () => {
        let pageData = { operation: "GetListOfAllProjects" };

        await fetch(global.variables.API_PROJECTDETAILS_GETLISTOFALLPROJECTS, {
            method: "POST",
            headers: {
                Authorization: "Bearer " + localStorage.getItem("authtoken"),
                Accept: "application/json",
                "Content-Type": "application/json"
            },
            body: JSON.stringify(pageData)
        })
            .then(response => response.json())
            .then(result => {
                console.log(result);

                this.setState({
                    projects: result.projects
                });
            });
    }

    loadBeneficiaries = async () => {

        await fetch(global.variables.API_DEFINITIONS_GETLISTOFBENEFICIARIES, {
            method: "POST",
            headers: {
                Authorization: "Bearer " + localStorage.getItem("authtoken"),
                Accept: "application/json",
                "Content-Type": "application/json"
            },
            body: JSON.stringify(this.state)
        })
            .then(response => response.json())
            .then(result => {
                console.log(result);

                if (result.resultstate == 2) {
                    this.setState({
                        loading: false,
                        notAuthorized: true
                    });
                } else {
                    this.setState({
                        beneficiarieslist: result.listofbeneficiaries,
                        loading: false,
                        notAuthorized: false
                    });
                }
            });
    };

    handleChange = (e) => {
        e.persist();
        this.setState({ [e.target.name]: e.target.value });
    }

    handleChangeDate = (name, value) => {
        console.log(name);
        console.log(value);

        this.setState({ [name]: new Date(moment(value).format('YYYY-MM-DD')) });
    };

    handleSelectChange = async (e, v, vname) => {
        e.persist();

        if (v !== undefined & v !== null) {
            await this.setState({ [vname]: v.TypeId });
        } else {
            await this.setState({ [vname]: -1 });
        }

        //console.log(vname + ": " + e.target.value);
        console.log(this.state);
    }

    handleSelectChangeUseValue = async (e, v, vname) => {
        e.persist();

        if (v !== undefined & v !== null) {
            await this.setState({ [vname]: v.TypeName });
        } else {
            await this.setState({ [vname]: "" });
        }

        console.log(this.state);
    }

    handleAddComponentOnClick = async (e) => {
        e.persist();

        await this.setState({ isFetching: true });

        let pageData = {
            operation: "AddComponent",
            selectedprojectid: this.props.match.params.id,
            selectedcomponentprojectid: this.state.selectedcomponentprojectid
        };

        await fetch(global.variables.API_PROJECTDETAILS_ADDCOMPONENT, {
            method: "POST",
            headers: {
                Authorization: "Bearer " + localStorage.getItem("authtoken"),
                Accept: "application/json",
                "Content-Type": "application/json"
            },
            body: JSON.stringify(pageData)
        })
            .then(response => response.json())
            .then(result => {
                console.log(result);

                if (result.resultstate === 0) {
                    toast.success("Success!", {
                        position: toast.POSITION.BOTTOM_RIGHT
                    });
                } else {
                    toast.error("Failed!", {
                        position: toast.POSITION.BOTTOM_RIGHT
                    });
                }

                this.loadPageComponents();
            });

        await this.setState({ isFetching: false });
    };

    //handleRemoveComponentOnClick = async (e) => {
    handleRemoveComponentOnClick = async (v) => {
        //e.persist();

        await this.setState({ isFetching: true });

        //var removecomponentwithid = e.currentTarget.attributes['data-id'].value;
        //var removecomponentwithid = e.target.attributes['data-id'].value;
        //var removecomponentwithid = e.currentTarget.getAttribute('data-id');
        //var removecomponentwithid = e.target.getAttribute('data-id');
        //var removecomponentwithid = e.target.attributes.getNamedItem('data-id').value;
        var removecomponentwithid = v;
        console.log(removecomponentwithid);

        let pageData = {
            operation: "RemoveComponent",
            selectedcomponentid: removecomponentwithid
        };

        await fetch(global.variables.API_PROJECTDETAILS_REMOVECOMPONENT, {
            method: "POST",
            headers: {
                Authorization: "Bearer " + localStorage.getItem("authtoken"),
                Accept: "application/json",
                "Content-Type": "application/json"
            },
            body: JSON.stringify(pageData)
        })
            .then(response => response.json())
            .then(result => {
                console.log(result);

                if (result.resultstate === 0) {
                    toast.success("Success!", {
                        position: toast.POSITION.BOTTOM_RIGHT
                    });
                } else {
                    toast.error("Failed!", {
                        position: toast.POSITION.BOTTOM_RIGHT
                    });
                }

                this.loadPageComponents();
            });

        await this.setState({ isFetching: false });
    };

    handleProjectSelectChange = async (e, v) => {
        e.persist();

        if (v !== undefined & v !== null) {
            await this.setState({
                selectedcomponentprojectid: v.idProjectDetails
            });
        } else {
            await this.setState({
                selectedcomponentprojectid: -1
            });
        }
    };

    handleFileUploadDelete = async (val) => {
        //console.log(val);

        if (val !== undefined & val !== null) {
            await this.handleDeleteProjectFiles(val);
        }
    }

    handleDeleteProjectFiles = async (val) => {

        await this.setState({ isFetching: true });

        let pageData = {
            operation: "DeleteProjectFiles",
            projectid: this.props.match.params.id,
            selectedProject: this.props.match.params.id,
            projectfileid: val,
        };

        //console.log(pageData);

        await fetch(global.variables.API_UPLOADFILESPAGE_DELETEPROJECTFILES, {
            method: "POST",
            headers: {
                Authorization: "Bearer " + localStorage.getItem("authtoken"),
                Accept: "application/json",
                "Content-Type": "application/json"
            },
            body: JSON.stringify(pageData)
        })
            .then(response => response.json())
            .then(result => {
                console.log(result);

                //this.setState({ dataDocuments: result.freeformwithprojectfiles });
            });

        await this.loadFreeFormWithProjectFiles();

        await this.setState({ isFetching: false });
    }

    //handleTestDOCXOnClick = async () => {
    //    console.log("TestClick DOCX OK");

    //    let pageData = {
    //        operation: "AutoGenerateXLSXDocument",
    //    };

    //    await fetch("/api/AutoGenerateDocument/AutoGenerateTestDocumentDOCX", {
    //        method: "POST",
    //        headers: {
    //            Authorization: "Bearer " + localStorage.getItem("authtoken"),
    //            Accept: "application/json",
    //            "Content-Type": "application/json"
    //        },
    //        body: JSON.stringify(pageData)
    //    })
    //        .then(response => response.json())
    //        .then(result => {
    //            console.log(result);

    //        });
    //}

    //handleTestXLSXOnClick = async () => {
    //    console.log("TestClick XLS OK");

    //    let pageData = {
    //        operation: "AutoGenerateXLSXDocument",
    //    };

    //    await fetch("/api/AutoGenerateDocument/AutoGenerateTestDocumentXLSX", {
    //        method: "POST",
    //        headers: {
    //            Authorization: "Bearer " + localStorage.getItem("authtoken"),
    //            Accept: "application/json",
    //            "Content-Type": "application/json"
    //        },
    //        body: JSON.stringify(pageData)
    //    })
    //        .then(response => response.json())
    //        .then(result => {
    //            console.log(result);

    //        });
    //}

    saveUpdateProject = async () => {

        await this.setState({ isFetching: true });

        //toast.success("Create Project!", {
        //    position: toast.POSITION.BOTTOM_RIGHT
        //});

        //console.log("Save Update Parameters: ");
        console.log(this.state);

        await fetch(global.variables.API_UPDATEPROJECT, {
            method: "POST",
            headers: {
                Authorization: "Bearer " + localStorage.getItem("authtoken"),
                Accept: "application/json",
                "Content-Type": "application/json"
            },
            body: JSON.stringify(this.state)
        })
            .then(response => response.json())
            .then(result => {
                console.log(result);

                if (result.resultstate === 0) {
                    toast.success("Update Project Success!", {
                        position: toast.POSITION.BOTTOM_RIGHT
                    });
                } else {
                    toast.error("Update Project Failed!", {
                        position: toast.POSITION.BOTTOM_RIGHT
                    });
                }
            });

        await this.setState({ isFetching: false });
    };

    onChangeFile = (event) => {
        //this.setState({
        //    file: e.target.files[0],
        //    filename: e.target.files[0].name
        //});

        //var filesvar = this.state.files;
        var filesvar = [];
        filesvar.push({
            filename: event.target.name,
            fileblob: event.target.files[0]
        });
        this.setState({ files: filesvar });

        this.setState({ filename: event.target.files[0].name });
    };

    doUpload = async () => {

        if (this.state.filename == "" || this.state.filename == null ||
            this.state.documentTitle == "" || this.state.documentTitle == null ||
            this.state.fileCategory == "" || this.state.fileCategory == null) {

            toast.warn("Please fill in the required inputs.", {
                position: toast.POSITION.BOTTOM_RIGHT
            });

            return;
        }

        await this.setState({ isFetching: true });

        console.log(this.state);

        var formData = new FormData();

        if (this.state.files && this.state.files.length > 0) {
            var filesarray = this.state.files;
            for (var i = 0; i < filesarray.length; i++) {
                //console.log("Appending files " + filesarray[i].filename);
                formData.append(filesarray[i].filename, filesarray[i].fileblob);
            }
        }

        var postData = this.state;
        Object.keys(postData).forEach((key, value) => {
            if (key !== "files" & key !== "projects") {
                formData.append(key, postData[key]);
            }
        });

        //console.log("DoUpload");
        //for (var pair of formData.entries()) {
        //    console.log(pair[0] + ', ' + pair[1]);
        //}

        await fetch(global.variables.API_UPLOADFILESPAGE_UPLOADFREEFORMFILES, {
            method: "POST",
            headers: {
                Authorization: "Bearer " + localStorage.getItem("authtoken"),
                //Accept: "application/json",
                //"Content-Type": "application/json"
            },
            body: formData
        })
            .then(response => response.json())
            .then(result => {
                console.log(result);

                if (result.resultstate === 0) {
                    toast.success("Success!", {
                        position: toast.POSITION.BOTTOM_RIGHT
                    });

                    this.loadFreeFormWithProjectFiles();
                } else {
                    toast.error("Failed!", {
                        position: toast.POSITION.BOTTOM_RIGHT
                    });
                }

                //this.pageLoad();
            });

        await this.setState({
            fileCategory: "",
            documentTitle: "",
            files: [],
            filename: ""
        });

        await this.setState({ isFetching: false });
    }

    getUserType = () => {
        let pageData = {
            operation: "GetUserType"
        };

        fetch(global.variables.API_USEROPERATIONS_GETUSERTYPE, {
            method: "POST",
            headers: {
                Authorization: "Bearer " + localStorage.getItem("authtoken"),
                Accept: "application/json",
                "Content-Type": "application/json"
            },
            body: JSON.stringify(pageData)
        })
            .then(response => response.json())
            .then(result => {
                console.log(result);

                this.setState({ userType: result.userType });
            });
    }

    //getUserRole = () => {
    //    let pageData = {
    //        operation: "GetUserRole",
    //        missionId: this.state.missionId
    //    };

    //    fetch(global.variables.API_USEROPERATIONS_GETUSERROLE, {
    //        method: "POST",
    //        headers: {
    //            Authorization: "Bearer " + localStorage.getItem("authtoken"),
    //            Accept: "application/json",
    //            "Content-Type": "application/json"
    //        },
    //        body: JSON.stringify(pageData)
    //    })
    //        .then(response => response.json())
    //        .then(result => {
    //            console.log(result);

    //            this.setState({ userRole: result.userRole });
    //        });
    //}

    returnArrayElement = (array, element) => {
        for (var i = 0; i < array.length; i++) {
            if (array[i].TypeId == element) {
                return array[i];
            }
        }

        return ({ TypeId: "", TypeName: "" });
    };

    returnArrayElementUseValue = (array, element) => {
        for (var i = 0; i < array.length; i++) {
            if (array[i].TypeName == element) {
                return array[i];
            }
        }

        return ({ TypeId: "", TypeName: "" });
    };

    render() {
        //const { typeOfROM, projectTitle, projectNumber, status, sector, smcsCode, cfcuContractManager, deuaSectorExpert, deuaMonitoringExpert, eudSectorManager, beneficiaryInstitution, contractingPartner,
        //    totalBudget, deuContribution, nationalCoFinancing, otherCoFinancing, paidAmount, lastDateOfPayment, contractorSignatureDate, projectStartDate, finalDate, reasonfortheRomReview, romExpertName, soMonitor, fieldPhaseStartDate } = this.state

        const { actualDate, plannedDate, detail, mrFile, mqFile, qualityChecklistFile, draftTemplateforSchedule, eRomHandbook, oRomHandbook, eInGuideline, oInGuideline, projects,
            projectDocuments, otherDocuments, typeOfROM, typeOfROMName, projectTitle, projectNumber, status, typeOfProject, sector, smcsCode, cfcuContractManager, deuaSectorExpert, deuaMonitoringExpert, eudSectorManager, beneficiaryInstitution, contractingPartner,
            totalBudget, deuContribution, nationalCoFinancing, otherCoFinancing, mainComponentBudget, paidAmount, lastDateOfPayment, contractorSignatureDate, projectStartDate, finalDate, reasonfortheRomReview, romExpertName, soMonitor, fieldPhaseStartDate,
            dataDocuments, dataMissions, projectMonitor, projectQualityController, beneficiaryName, beneficiarySurname, beneficiaryCompany, beneficiaryEmail, beneficiaries, users, monuserid, qcuserid,
            components, coMonitor, fieldPhaseEndDate, euContribution, totalFundsDisbursed, contactAtBeneficiaryInstitution, teamLeaderPartner, annualType, IPAType, FAType, FAMAType, data,
            isFetching, beneficiaryUnitDepartment, fileCategory, uploadCategories, userType, beneficiarieslist, documentTitle } = this.state;

        const columnsDocuments = [
            {
                name: "idFreeFormProjectFiles",
                options: {
                    display: false
                }
            },
            {
                name: "DocumentTitle",
                label: "Document Title",
                options: {
                    filter: true,
                    sort: true
                }
            },
            {
                name: "UploadDatetime",
                label: "Date and Time",
                options: {
                    filter: true,
                    sort: true
                }
            },
            {
                name: "FreeFormProjectFileCategoryName",
                label: "File Category",
                options: {
                    filter: true,
                    sort: true
                }
            },
            {
                name: "fkUploadedFiles",
                options: {
                    display: false
                }
            },
            {
                name: "OriginalFilename",
                options: {
                    display: false
                }
            },
            {
                name: "Actions",
                options: {
                    filter: false,
                    sort: false,
                    customBodyRender: (value, tableMeta, updateValue) => {
                        //return (
                        //    <div>
                        //        <Button
                        //            variant="outlined"
                        //            color="primary"
                        //            component="a"
                        //            href={"test"}
                        //        >
                        //            Download
                        //        </Button>
                        //        {
                        //            //<Button variant="outlined" color="primary">
                        //            //    Edit
                        //            //</Button>
                        //        }
                        //        <Button
                        //            style={{ marginLeft: 5 }}
                        //            variant="outlined"
                        //            color="secondary"
                        //        >
                        //            Delete
                        //        </Button>
                        //    </div>
                        //);

                        return (
                            <div>
                                <Button
                                    style={{
                                        width: 117,
                                        height: 37,
                                        marginLeft: 5
                                    }}
                                    variant="outlined"
                                    color="primary"
                                    component="a"
                                    href={"/api/FileUploadDownload/DownloadFileId/" + btoa(localStorage.getItem("authtoken")) + "/" + tableMeta.rowData[4]}
                                    //download={tableMeta.rowData[1]}
                                    download={tableMeta.rowData[5]}
                                    //target="_blank"
                                    disabled={isFetching ? true : false}
                                >
                                    Download
                                </Button>
                                {
                                    //<Button variant="outlined" color="primary">
                                    //    Edit
                                    //</Button>
                                }
                                <Button
                                    //style={{ marginLeft: 5, display: userType === 4 ? "block" : "none" }}
                                    style={{
                                        width: 117,
                                        height: 37,
                                        marginLeft: 5,
                                        //display: userType === 2 || userType === 3 ? "block" : "none"
                                        display: userType === 2 ? "block" : "none"
                                    }}
                                    variant="outlined"
                                    color="secondary"
                                    onClick={() => this.handleFileUploadDelete(tableMeta.rowData[0])}
                                    disabled={isFetching ? true : false}
                                >
                                    Delete
                                </Button>
                            </div>
                        );
                    }
                }
            }
        ];

        const columnsMissions = [
            {
                name: "idMissionDetails",
                options: {
                    display: false
                }
            },
            {
                name: "MissionNumber",
                label: "Mission Number",
                options: {
                    filter: true,
                    sort: true
                }
            },
            {
                name: "FieldPhaseStartDate",
                label: "Field Phase Start Date",
                options: {
                    filter: true,
                    sort: true
                }
            },
            {
                name: "FieldPhaseEndDate",
                label: "Field Phase End Date",
                options: {
                    filter: true,
                    sort: true
                }
            }
            //{
            //    name: "ROMExpertsNames",
            //    label: "ROM Expert Name",
            //    options: {
            //        filter: true,
            //        sort: true
            //    }
            //},
            //{
            //    name: "COMonitor",
            //    label: "CO-Monitor",
            //    options: {
            //        filter: true,
            //        sort: true
            //    }
            //}
        ];

        const options = {
            filterType: "checkbox",
            selectableRows: "none",
            selectableRowsOnClick: false,
        };



        if (userType === -1) {
            //return (
            //    <div />
            //);
            return (
                <CircularProgress />
            );
        } else {

            return (

                <Grid container spacing={3} >
                    <Grid>
                        <ToastContainer />
                    </Grid>

                    {
                        //<Grid item xs={6} height="100%">
                        //    <ProjectDataView
                        //        typeOfROM={typeOfROM}
                        //        projectTitle={projectTitle}
                        //        projectNumber={projectNumber}
                        //        status={status}
                        //    />
                        //</Grid>
                        //<Grid item xs={6} height="100%">
                        //    <ProjectKeyInformationView
                        //        onChange={this.handleChange}
                        //        sector={sector}
                        //        smcsCode={smcsCode}
                        //    />

                        //</Grid>
                        //<Grid item xs={6} height="100%">
                        //    <EntityInChargeView
                        //        onChange={this.handleChange}
                        //        cfcuContractManager={cfcuContractManager}
                        //        deuaSectorExpert={deuaSectorExpert}
                        //        deuaMonitoringExpert={deuaMonitoringExpert}
                        //        eudSectorManager={eudSectorManager}
                        //        beneficiaryInstitution={beneficiaryInstitution}
                        //        contractingPartner={contractingPartner}
                        //    />
                        //</Grid>
                        //<Grid item xs={6} height="100%">
                        //    <ProjectFinancialDataView
                        //        onChange={this.handleChange}
                        //        totalBudget={totalBudget}
                        //        deuContribution={deuContribution}
                        //        nationalCoFinancing={nationalCoFinancing}
                        //        otherCoFinancing={otherCoFinancing}
                        //        paidAmount={paidAmount}
                        //        lastDateOfPayment={lastDateOfPayment}
                        //    />
                        //</Grid>
                        //<Grid item xs={6} height="100%">
                        //    <ProjectDatesView
                        //        onChange={this.handleChange}
                        //        contractorSignatureDate={contractorSignatureDate}
                        //        projectStartDate={projectStartDate}
                        //        finalDate={finalDate}
                        //    />
                        //</Grid>
                        //<Grid item xs={6} height="100%">
                        //    <RomReviewView
                        //        onChange={this.handleChange}
                        //        reasonfortheRomReview={reasonfortheRomReview}
                        //        romExpertName={romExpertName}
                        //        soMonitor={soMonitor}
                        //        fieldPhaseStartDate={fieldPhaseStartDate}
                        //    />
                        //</Grid>
                    }

                    {
                        //<Grid item xs={6} height="100%">
                        //    <ProjectDataView
                        //        typeOfROM={this.state.projectDetails.typeOfROMName}
                        //        projectTitle={this.state.projectDetails.ProjectTitle}
                        //        projectNumber={this.state.projectDetails.ProjectNumber}
                        //        status={this.state.projectDetails.Status}
                        //    />
                        //</Grid>
                        //<Grid item xs={6} height="100%">
                        //    <ProjectKeyInformationView
                        //        sector={this.state.projectDetails.Sector}
                        //        smcsCode={this.state.projectDetails.SMCSCode}
                        //    />
                        //</Grid>
                        //<Grid item xs={6} height="100%">
                        //    <EntityInChargeView
                        //        cfcuContractManager={this.state.projectDetails.CFCUContractManager}
                        //        deuaSectorExpert={this.state.projectDetails.DEUASectorExpert}
                        //        deuaMonitoringExpert={this.state.projectDetails.DEUAMonitoringExpert}
                        //        eudSectorManager={this.state.projectDetails.EUDSectorManager}
                        //        beneficiaryInstitution={this.state.projectDetails.BeneficiaryInstitution}
                        //        contractingPartner={this.state.projectDetails.ContractingPartner}
                        //    />
                        //</Grid>
                        //<Grid item xs={6} height="100%">
                        //    <ProjectFinancialDataView
                        //        totalBudget={this.state.projectDetails.TotalBudget}
                        //        deuContribution={this.state.projectDetails.DEUContribution}
                        //        nationalCoFinancing={this.state.projectDetails.NationalCoFinancing}
                        //        otherCoFinancing={this.state.projectDetails.OtherCoFinancing}
                        //        paidAmount={this.state.projectDetails.PaidAmount}
                        //        lastDateOfPayment={this.state.projectDetails.LastDateOfPayment}
                        //    />
                        //</Grid>
                        //<Grid item xs={6} height="100%">
                        //    <ProjectDatesView
                        //        contractorSignatureDate={this.state.projectDetails.ContractorSignatureDate}
                        //        projectStartDate={this.state.projectDetails.ProjectStartDate}
                        //        finalDate={this.state.projectDetails.FinalDate}
                        //    />
                        //</Grid>
                        //<Grid item xs={6} height="100%">
                        //    <RomReviewView
                        //        reasonfortheRomReview={this.state.projectDetails.ReasonfortheROMReview}
                        //        romExpertName={this.state.projectDetails.ROMExpertsNames}
                        //        soMonitor={this.state.projectDetails.SOMonitor}
                        //        fieldPhaseStartDate={this.state.projectDetails.FieldPhaseStartDate}
                        //    />
                        //</Grid>
                    }

                    <Grid container spacing={3} >
                        <Grid item xs={6} height="100%">
                            <ProjectData
                                onChange={this.handleChange}
                                //onChangetypeOfROM={this.handletypeOfROMSelectChange}
                                //typeOfROM={typeOfROM}
                                projectTitle={projectTitle}
                                projectNumber={projectNumber}
                                status={status}
                                userType={userType}
                            />
                        </Grid>
                        <Grid item xs={6} height="100%">
                            <ProjectKeyInformation
                                onChange={this.handleChange}
                                onSelectChange={this.handleSelectChange}
                                typeOfProject={typeOfProject}
                                sector={sector}
                                smcsCode={smcsCode}
                                annualType={annualType}
                                IPAType={IPAType}
                                FAType={FAType}
                                FAMAType={FAMAType}
                                userType={userType}
                            />
                        </Grid>
                        <Grid item xs={6} height="100%">
                            <EntityInCharge
                                onChange={this.handleChange}
                                onSelectChangeUseValue={this.handleSelectChangeUseValue}
                                cfcuContractManager={cfcuContractManager}
                                deuaSectorExpert={deuaSectorExpert}
                                deuaMonitoringExpert={deuaMonitoringExpert}
                                eudSectorManager={eudSectorManager}
                                beneficiaryInstitution={beneficiaryInstitution}
                                beneficiaryUnitDepartment={beneficiaryUnitDepartment}
                                contractingPartner={contractingPartner}
                                contactAtBeneficiaryInstitution={contactAtBeneficiaryInstitution}
                                teamLeaderPartner={teamLeaderPartner}
                                userType={userType}
                                beneficiaryInstitutionOptions={beneficiarieslist}
                            />
                        </Grid>
                        <Grid item xs={6} height="100%">
                            <ProjectFinancialData
                                onChange={this.handleChange}
                                onChangeDate={(name, value) =>
                                    this.handleChangeDate(name, value)
                                }
                                totalBudget={totalBudget}
                                euContribution={euContribution}
                                nationalCoFinancing={nationalCoFinancing}
                                otherCoFinancing={otherCoFinancing}
                                mainComponentBudget={mainComponentBudget}
                                totalFundsDisbursed={totalFundsDisbursed}
                                lastDateOfPayment={lastDateOfPayment}
                                userType={userType}
                            />
                        </Grid>
                        <Grid item xs={6} height="100%">
                            <ProjectDates
                                onChange={(name, value) => this.handleChangeDate(name, value)}
                                contractorSignatureDate={contractorSignatureDate}
                                projectStartDate={projectStartDate}
                                finalDate={finalDate}
                                userType={userType}
                            />
                        </Grid>
                        {
                            //<Grid item xs={6} height="100%">
                            //    <RomReview
                            //        onChangeDate={(name, value) =>
                            //            this.handleChangeDate(name, value)
                            //        }
                            //        onChange={this.handleChange}
                            //        reasonfortheRomReview={reasonfortheRomReview}
                            //        romExpertName={romExpertName}
                            //        coMonitor={coMonitor}
                            //        fieldPhaseStartDate={fieldPhaseStartDate}
                            //        fieldPhaseEndDate={fieldPhaseEndDate}
                            //    />
                            //</Grid>
                        }
                        <Grid item xs={12} style={{
                            textAlign: "center",
                            display: userType === 2 ? "block" : "none"
                        }}>
                            <Button
                                variant="contained"
                                color="primary"
                                onClick={this.saveUpdateProject}
                                disabled={isFetching ? true : false}
                            >
                                Update Project
                    </Button>
                            {
                                //<Button
                                //    variant="contained"
                                //    color="primary"
                                //    onClick={() => {
                                //        console.log(stores.userStore.fullName);
                                //        stores.userStore.setFirstName("ayse");
                                //    }}
                                //>
                                //    Mobx Action
                                //</Button>
                            }
                        </Grid>
                        <Grid>
                            <ToastContainer />
                        </Grid>
                    </Grid >

                    {
                        //<Grid item xs={12} className="mt-2">
                        //    <DashboardRomTemplates
                        //        mrFile={mrFile}
                        //        mqFile={mqFile}
                        //        qualityChecklistFile={qualityChecklistFile}
                        //        draftTemplateforSchedule={draftTemplateforSchedule}
                        //        testOnDOCXClick={this.handleTestDOCXOnClick}
                        //        testOnXLSXClick={this.handleTestXLSXOnClick}
                        //    />
                        //</Grid>
                    }

                    <Grid item xs={12} className="mt-2">
                        <DashboardRomDocuments
                            eRomHandbook={eRomHandbook}
                            oRomHandbook={oRomHandbook}
                            eInGuideline={eInGuideline}
                            oInGuideline={oInGuideline}
                        />
                    </Grid>

                    <Grid item xs={12} style={{
                        display: userType === 2 ? "block" : "none"
                    }}>
                        <Card>
                            <CardHeader
                                title="Upload New File"
                                className="romis-card-header"
                            ></CardHeader>
                            <CardContent>
                                <input
                                    //accept="*/*"
                                    style={{ display: "none" }}
                                    id="contained-button-file"
                                    //multiple
                                    type="file"
                                    //fullwidth="true"
                                    onChange={this.onChangeFile}
                                    name="freeFormFile"
                                />
                                <label htmlFor="contained-button-file" style={{ width: "100%" }}>
                                    <Button
                                        variant="outlined"
                                        color="primary"
                                        size="large"
                                        component="span"
                                        fullWidth
                                        startIcon={<AttachFileIcon />}
                                        disabled={isFetching ? true : false}
                                    >
                                        Select File
                                </Button>
                                </label>
                                <Typography
                                    variant="caption"
                                    component="h2"
                                    style={{
                                        display: "none" ? this.state.filename === "" : "block"
                                    }}
                                >
                                    {this.state.filename}
                                </Typography>

                                <TextField
                                    name="documentTitle"
                                    label="Document Title"
                                    fullWidth
                                    margin="normal"
                                    onChange={this.handleChange}
                                    value={documentTitle}
                                />

                                <Autocomplete
                                    options={uploadCategories}
                                    getOptionLabel={option => option.TypeName}
                                    autoComplete
                                    includeInputInList
                                    onChange={(e, v) => this.handleSelectChange(e, v, "fileCategory")}
                                    value={this.returnArrayElement(uploadCategories, fileCategory)}
                                    renderInput={params => (
                                        <TextField
                                            {...params}
                                            name={fileCategory}
                                            label="Select Category"
                                            placeholder="File Category"
                                            margin="normal"
                                            fullWidth
                                        />
                                    )}
                                />

                                {
                                    //<Autocomplete
                                    //    options={categories}
                                    //    getOptionLabel={option => option.title}
                                    //    autoComplete
                                    //    includeInputInList
                                    //    renderInput={params => (
                                    //        <TextField
                                    //            {...params}
                                    //            label="Select Category"
                                    //            margin="normal"
                                    //            fullWidth
                                    //        />
                                    //    )}
                                    ///>
                                }

                                {
                                    //<Autocomplete
                                    //    options={projects}
                                    //    getOptionLabel={option => option.ProjectTitle + " " + option.ProjectNumber}
                                    //    autoComplete
                                    //    includeInputInList
                                    //    onChange={this.handleProjectSelectChange.bind(this)}
                                    //    renderInput={params => (
                                    //        <TextField
                                    //            {...params}
                                    //            label="Select Project"
                                    //            margin="normal"
                                    //            fullWidth
                                    //        />
                                    //    )}
                                    ///>
                                }

                                <Grid item xs={12} style={{
                                    textAlign: "center",
                                    display: userType === 2 || userType === 3 ? "block" : "none"
                                }}>
                                    <Button
                                        variant="contained"
                                        color="primary"
                                        size="large"
                                        className="mt-1"
                                        startIcon={<CloudUploadIcon />}
                                        onClick={this.doUpload.bind(this)}
                                        disabled={isFetching ? true : false}
                                    >
                                        Upload
                                </Button>
                                </Grid>

                                <Grid item xs={12} style={{ textAlign: "center", display: isFetching ? "block" : "none" }}>
                                    <CircularProgress style={{ display: isFetching ? "block" : "none" }} />
                                </Grid>

                            </CardContent>
                        </Card>
                    </Grid>

                    <Grid item xs={12} className="mt-2">
                        {
                            //<DashboardDocuments title="Project Documents" documents={projectDocuments} />
                        }

                        <Card>
                            <CardHeader
                                title="Project Documents"
                                className="romis-card-header"
                            ></CardHeader>
                            <CardContent>
                                <MUIDataTable
                                    title={"Documents"}
                                    data={dataDocuments}
                                    columns={columnsDocuments}
                                    options={options}
                                />
                            </CardContent>
                        </Card>
                    </Grid>

                    <Grid item xs={12} className="mt-1">
                        <Card>
                            {
                                //<CardHeader title="Add Beneficiary" className="romis-card-header"></CardHeader>
                            }
                            <CardHeader title="Link Component Project" className="romis-card-header"></CardHeader>
                            <CardContent>
                                <Grid container spacing={2}>
                                    <Grid item xs={11} style={{
                                        display: userType === 2 ? "block" : "none"
                                    }}>
                                        {
                                            //<TextField
                                            //    fullWidth
                                            //    placeholder="E-Mail"
                                            //    margin="normal"
                                            //    onChange={this.handleChange.bind(this)}
                                            //    value={beneficiaryEmail}
                                            //    name="beneficiaryEmail"
                                            ///>
                                        }
                                        <Autocomplete
                                            options={projects}
                                            getOptionLabel={option => option.ProjectTitle}
                                            autoComplete
                                            includeInputInList
                                            onChange={this.handleProjectSelectChange.bind(this)}
                                            renderInput={params => (
                                                <TextField {...params} label="Projects" margin="normal" fullWidth />
                                            )}
                                        />
                                    </Grid>
                                    <Grid item xs={1} style={{
                                        display: userType === 2 ? "block" : "none"
                                    }}>
                                        <Button variant="contained" color="primary" className="mt"
                                            onClick={this.handleAddComponentOnClick.bind(this)}
                                            disabled={isFetching ? true : false}
                                        >
                                            Add
                                    </Button>
                                    </Grid>
                                </Grid>
                                <Table aria-label="simple table" className="mt-1">
                                    <TableHead>
                                        <TableRow>
                                            <TableCell align="left">Project Number</TableCell>
                                            <TableCell align="left">Project Title</TableCell>
                                            <TableCell align="left">Project Type</TableCell>
                                            <TableCell align="left">Options</TableCell>
                                            <TableCell align="left"></TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {components.map(({ idProjectComponents, fkMainProjectId, fkComponentProjectId, ProjectTitle, ProjectNumber, TypeOfProjectName }, index) => {
                                            return (
                                                <TableRow key={idProjectComponents}>
                                                    {
                                                        //<TableCell align="left">{ProjectNumber + " " + idProjectComponents}</TableCell>
                                                    }
                                                    <TableCell align="left">{ProjectNumber}</TableCell>
                                                    <TableCell align="left">{ProjectTitle}</TableCell>
                                                    <TableCell align="left">{TypeOfProjectName}</TableCell>
                                                    <TableCell align="left">
                                                        <Button variant="outlined" color="secondary"
                                                            //data-id={idProjectComponents}
                                                            //onClick={this.handleRemoveComponentOnClick.bind(this)}
                                                            onClick={() => this.handleRemoveComponentOnClick(idProjectComponents)}
                                                            disabled={isFetching ? true : false}
                                                            style={{
                                                                display: userType === 2 ? "block" : "none"
                                                            }}
                                                        >
                                                            Remove
                 									 </Button>
                                                    </TableCell>
                                                    <TableCell align="left"><a href={"/projectdetails/" + fkComponentProjectId}><ArrowForwardIcon /></a></TableCell>
                                                </TableRow>
                                            )
                                        })}
                                    </TableBody>
                                </Table>
                            </CardContent>
                        </Card>
                    </Grid>

                    <Grid item xs={12} className="mt-2">
                        <Card>
                            <CardHeader
                                title="Missions"
                                className="romis-card-header"
                            ></CardHeader>
                            <CardContent>
                                <MaterialTable
                                    columns={[
                                        { title: 'Mission Id', field: 'idMissionDetails', hidden: true },
                                        { title: 'Mission Number', field: 'MissionNumber' },
                                        { title: 'Field Phase Start Date', field: 'FieldPhaseStartDate' },
                                        { title: 'Field Phase End Date', field: 'FieldPhaseEndDate' },
                                    ]}
                                    data={dataMissions}
                                    title="Missions"
                                    actions={[
                                        {
                                            icon: 'launch',
                                            tooltip: 'Mission Details',
                                            onClick: (event, rowData) => {
                                                this.props.history.push(`/missiondetails/${rowData.idMissionDetails}`);
                                            },
                                        }
                                    ]}
                                    options={{
                                        actionsColumnIndex: -1,
                                        pageSize: 20
                                    }}
                                />
                            </CardContent>
                        </Card>
                    </Grid>

                    {
                        //<Grid item xs={12} className="mt-2">
                        //    <DashboardDocuments title="Other Documents" documents={otherDocuments} />
                        //</Grid>
                    }
                    {
                        //            <Button variant="contained" color="primary" onClick={() => {
                        //                console.log(stores.userStore.fullName)
                        //                stores.userStore.setFirstName("ahmet")
                        //            }}>
                        //                Mobx Action
                        //</Button>
                    }
                </Grid >
            );
        }
    }
}



// WEBPACK FOOTER //
// ./src/pages/ProjectDetailsPage.js